import React from "react";
import { PaginationWrap, PaginationButton, PageNumbers, PageNumber, Ellipsis, NavigationButtons } from "./StyledNumberPaginationBox";

export default function NumberPaginationBox(props: {
	page: number;
	count: number;
	per: number;
	onChange: (page: number) => void;
	siblingCount?: number;
	boundaryCount?: number;
}) {
	const totalPages = Math.ceil(props.count / props.per) || 1;
	const currentPage = props.page;
	
	const renderPageNumbers = () => {
		const pages = [];
		const siblingCount = props.siblingCount || 1;
		const boundaryCount = props.boundaryCount || 1;
		
		if (totalPages > 0) {
			pages.push(
				<PageNumber 
					key={1} 
					active={currentPage === 1}
					onClick={() => props.onChange(1)}
				>
					1
				</PageNumber>
			);
		}
		
		const start = Math.max(2, currentPage - siblingCount);
		if (start > 2) {
			pages.push(<Ellipsis key="start-ellipsis">...</Ellipsis>);
		}
		
		const end = Math.min(totalPages - 1, currentPage + siblingCount);
		for (let i = start; i <= end; i++) {
			if (i !== 1 && i !== totalPages) {
				pages.push(
					<PageNumber 
						key={i} 
						active={currentPage === i}
						onClick={() => props.onChange(i)}
					>
						{i}
					</PageNumber>
				);
			}
		}
		
		if (end < totalPages - 1) {
			pages.push(<Ellipsis key="end-ellipsis">...</Ellipsis>);
		}
		
		if (totalPages > 1) {
			pages.push(
				<PageNumber 
					key={totalPages} 
					active={currentPage === totalPages}
					onClick={() => props.onChange(totalPages)}
				>
					{totalPages}
				</PageNumber>
			);
		}
		
		return pages;
	};

	return (
		<PaginationWrap>
			<PageNumbers>
				{renderPageNumbers()}
			</PageNumbers>
			
			<NavigationButtons>
				<PaginationButton 
					disabled={currentPage === 1}
					onClick={() => props.onChange(currentPage - 1)}
				>
					<img src="./static/img/debt/ar-left.png" alt="Previous" style={{width: '16px', height: '16px', marginRight: '8px'}} />
					Previous
				</PaginationButton>
				
				<PaginationButton 
					disabled={currentPage === totalPages}
					onClick={() => props.onChange(currentPage + 1)}
				>
					Next
					<img src="./static/img/debt/ar-right.png" alt="Next" style={{width: '16px', height: '16px', marginLeft: '8px'}} />
				</PaginationButton>
			</NavigationButtons>
		</PaginationWrap>
	);
}
